<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerKADLs">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(kADL)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { KADLService } from "../../../services/KADLService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "KADLPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      kADL: null,
      kADLService: new KADLService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerKADLs() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.kADL) {
        return {
          title: this.kADL.value,
          id: this.ids[0],
          status: this.getStatus(this.kADL.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.kADL) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.kADL.code,
            },
          ],
          [
            {
              title: this.$t("kADLValue"),
              text: this.kADL.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.kADL) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.kADL.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.kADL.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.kADL.createdAt) +
                " " +
                getAMorPM(this.kADL.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.kADL.lastUpdated) +
                " " +
                getAMorPM(this.kADL.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.kADL)
        : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getKADL();
      } catch (e) {
        this.hasError = true;
      }
    },
    getKADL() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.kADLService.get(this.ids[0]).then((res) => {
          this.kADL = res.data;
          this.loading = false;
        });
      }
      this.kADL = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.kADL);
    },
    deletePanel() {
      this.$emit("delete", this.kADL);
    },
    showHistoryPanel() {
      this.$emit("history", this.kADL);
    },
  },
};
</script>

<style scoped></style>
